export const actionTypes = {
    SET_PRODUCTS: "SET_PRODUCTS",
    SELECTED_PRODUCT: "SELECTED_PRODUCT",
    RESET_PRODUCT: "RESET_PRODUCT",
}